import JackpotHeader from './JackpotHeader';

export default JackpotHeader;